import { ContractChangeStatusEnum } from 'gql/graphql';

export const statusItemFromId = {
    [ContractChangeStatusEnum.Formation]: { label: 'На формировании', id: ContractChangeStatusEnum.Formation },
    [ContractChangeStatusEnum.Approving]: { label: 'На согласовании', id: ContractChangeStatusEnum.Approving },
    [ContractChangeStatusEnum.Approved]: { label: 'Согласован', id: ContractChangeStatusEnum.Approved },
    [ContractChangeStatusEnum.Delayed]: { label: 'Отложен', id: ContractChangeStatusEnum.Delayed },
};
